import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import ExtendedDetails from './ExtendedDetails';
import ProjectColumnEmptyState from './ProjectColumnEmptyState';
import { PROJECTS } from '../services/projects.services';
import {
  PROJECT_EMPTY_STATES,
  PROJECT_EMPTY_STATES_KEYS
} from '../projects.consts.js';

const ProjectRow = styled(Flex)`
  background: ${getColor('white')};
  border-top: 1px solid ${getColor('catskillWhite')};
`;

const StyledTitle = styled(Flex)`
  font-size: 1.2rem;
`;

const ChartColumn = ({
  showChart,
  chartTitle,
  chartComponent,
  isShowIssuesTable
}) => {
  if (showChart) {
    return (
      <Flex minWidth={PROJECTS.LARGE_CHART_SIZE.width}>
        <Flex direction='column'>
          <StyledTitle pb={SPACES['x-x-small']}>{chartTitle}</StyledTitle>
          <Flex style={PROJECTS.LARGE_CHART_SIZE}>{chartComponent}</Flex>
        </Flex>
      </Flex>
    );
  }

  return (
    !isShowIssuesTable && <Flex minWidth={PROJECTS.LARGE_CHART_SIZE.width} />
  );
};

const ProjectExtendedView = ({
  projectExtendedData,
  isSingleIterationView,
  rowHeight,
  isShowIssuesTable
}) => {
  return projectExtendedData.map(
    ({
      icon,
      type,
      total,
      filter,
      articleId,
      chartTitle,
      pieComponent,
      chartComponent,
      emptyStateKey
    }) => {
      return (
        <ProjectRow key={type} padding='medium' height={rowHeight}>
          <Flex width='100%' minHeight={rowHeight}>
            <ExtendedDetails
              icon={icon}
              name={type}
              total={total}
              filter={filter}
              articleId={articleId}
            />

            <Flex width='100%' items='center' justify='center'>
              <Flex width='calc(48rem + 80px)'>
                {emptyStateKey ? (
                  <ProjectColumnEmptyState
                    {...PROJECT_EMPTY_STATES[
                      PROJECT_EMPTY_STATES_KEYS[emptyStateKey]
                    ]}
                  />
                ) : (
                  pieComponent
                )}
              </Flex>
            </Flex>
            <ChartColumn
              showChart={!isSingleIterationView && !emptyStateKey}
              chartTitle={chartTitle}
              chartComponent={chartComponent}
              isShowIssuesTable={isShowIssuesTable}
            />
          </Flex>
        </ProjectRow>
      );
    }
  );
};

export default ProjectExtendedView;
